<template>
  <div class="item-tile" data-cy="item-tile">
    <header class="item-tile__header">
      <a
        class="item-tile__link"
        :class="{ active: type == SubApplicationType.Add }"
        @click="openApplicationForm"
        data-cy="item-tile-link"
      >
        <font-awesome-icon
          v-if="type == SubApplicationType.Add"
          icon="fa-solid fa-pen-to-square"
          data-cy="item-tile-icon"
        />
        {{ ingredient.LabelNumber || ingredient.LabelName ?
          `${ingredient.LabelNumber} ${ingredient.LabelName}` :
          "LABEL NAME NOT AVAILABLE"
        }}
      </a>

      <div class="pull-right">
        <a
          class="item-tile__remove"
          ref="item-tile-remove"
          @click="onRemoveClicked"
          data-cy="item-tile-remove"
        >
          <font-awesome-icon class="remove-icon" icon="fa-solid fa-warning" />
          Delete
        </a>
      </div>
    </header>
    <div class="item-tile__content">
      <span data-cy="item-tile-distributor-name">{{
        ingredient.DistributorCompanyName
      }}</span>
      <span v-if="ingredient.BrandName" data-cy="item-tile-brand-name"
        >Brand: {{ ingredient.BrandName }}</span
      >
      <span v-if="ingredient.AgencyId" data-cy="item-tile-agency-id"
        >Ukd Id: {{ ingredient.AgencyId }}</span
      >
      <span v-if="ingredient.Rmc" data-cy="item-tile-rmc"
        >RMC: {{ ingredient.Rmc }}</span
      >
      <span data-cy="item-tile-plant-name"
        >{{ ingredient.PlantName }} [{{ ingredient.PlantType }}]</span
      >
      <span v-if="ingredient.VueScheduleACartStatus" data-cy="item-tile-status"
        >Ingredient Status in Plant:
        {{ ingredient.VueScheduleACartStatus }}</span
      >
      <span
        v-if="ingredient.NumberOfAttachments"
        data-cy="item-tile-label-attachments"
        >Documents: {{ ingredient.NumberOfAttachments }}</span
      >

      <span
        v-if="ingredient.VueIngredientStatusForCustomerDisplay"
        class="item-tile-status"
        data-cy="item-tile-customer-status"
      >
        {{ ingredient.VueIngredientStatusForCustomerDisplay }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SubApplicationType } from "@/Domain/SubApplicationType";
import type { IngredientDisplayInCart } from "@/Domain/IngredientDisplayInCart";

const props = defineProps<{
  type: SubApplicationType;
  ingredient: IngredientDisplayInCart;
}>();

const emit = defineEmits<{
  (e: "editClicked"): void;
  (e: "removeClicked"): void;
}>();

const openApplicationForm = () => {
  if (props.type != SubApplicationType.Add) return;
  emit("editClicked");
};

const onRemoveClicked = () => {
  emit("removeClicked");
};
</script>

<style lang="scss">
.item-tile {
  border: 1px solid #ccc;
  background: #f7f7f7;
  border-radius: 5px;
  padding: 10px;
  margin: 10px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  &__link {
    color: #000;
    text-decoration: none;
    font-weight: bold;
    font-size: 1.1rem;
    line-height: 1.2rem;

    &.active {
      color: #337ab7;
      cursor: pointer;
    }
  }

  &__remove {
    color: #dc3545;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
    align-items: center;
  }

  .remove-icon {
    margin-top: -2px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    line-height: 1.2rem;
  }

  &-status {
    margin: 10px;
    text-align: center;
    color: #58b758;
    font-style: italic;
  }
}
</style>
